<template>
  <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
    <treeselect v-model="selected" :options="options" :multiple="multiple"
                :auto-load-root-options="autoLoadRootOptions" :load-options="loadOptions"
                :value-consists-of="'LEAF_PRIORITY'" :limit="3" @input="input"
                :noChildrenText="noChildrenText" :noResultsText="noResultsText"
                :noOptionsText="noOptionsText" :placeholder="placeholder" :loading-text="loadingText"
                :retryText="retryText" :retryTitle="retryTitle" :searchPromptText="searchPromptText"
                :limit-text="limitText"
    ></treeselect>
  </b-form-group>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import i18n from '@/i18n';
import getUserLocale from 'get-user-locale';

export default {
  name: "ClientUserTreeSelect",
  components: {Treeselect},
  props: {
    model: Object,
    attribute: {
      type: String,
      default: 'user'
    },
    field: {
      type: String,
      default: '_id'
    },
    autoLoadRootOptions: {
      type: Boolean,
      default: true
    },
    multiple: Boolean,
    label: {
      type: String,
      default: i18n.t('chooseAgents')
    },
    noChildrenText: {
      type: String,
      default: i18n.t('noUsersInThisGroup')
    },
    noOptionsText: {
      type: String,
      default: i18n.t('noOptionsText')
    },
    noResultsText: {
      type: String,
      default: i18n.t('noResultsText')
    },
    placeholder: {
      type: String,
      default: i18n.t('selectUser')
    },
    retryText: {
      type: String,
      default: i18n.t('retryText')
    },
    retryTitle: {
      type: String,
      default: i18n.t('retryTitle')
    },
    searchPromptText: {
      type: String,
      default: i18n.t('loading')
    },
    loadingText: {
      type: String,
      default: i18n.t('loading')
    },
    errors: Array,
    groupsFilter: Array
  },
  computed: {

  },
  data() {
    return {
      errorTxt: '',
      selected: [],
      state: null,
      options: null,
    }
  },
  methods: {
    limitText(count) {
      return i18n.t('limitTextUser', [count])
    },
    async loadOptions() {
      this.options = [];
      if (this.multiple) {
        let groups = [];
        let filter = {
          page: 1,
          pageSize: 100,
          status: 0,
        }
        if (this.groupsFilter && this.groupsFilter.length) {
          if (this.groupsFilter.includes('default')) {
            groups = [{_id: 'default', name: this.$t('default')}];
          }
          filter.ids = this.groupsFilter.join(',');
        } else {
          groups = [{_id: 'default', name: this.$t('default')}];
        }
        let res = await this.$service.get('/user-group', {params: filter})
        if (res && res.data) {
          groups = groups.concat(res.data.docs);
        }
        for (let g of groups) {
          let option = {id: 'group' + g._id, label: g.name, children: []};
          let res2 = await this.$service.get('/user', {
            params: {
              page: 1,
              pageSize: 200,
              status: 0,
              group: g._id,
            }
          })
          if (res2 && res2.data) {
            for (let u of res2.data.docs) {
              option.children.push({id: u[this.field], label: `${u.name} - ${u.ext} - ${u.email}`})
            }
          }
          this.options.push(option);
        }
      } else {
        let response = await this.$service.get('/user', {
          params: {
            page: 1,
            pageSize: 100,
            status: 0,
          }
        })
        if (response && response.data) {
          response.data.docs.forEach(user => {
            this.options.push({id: user[this.field], label: `${user.name} - ${user.ext} - ${user.email}`})
          })
        }
      }
      this.loadSelected();
    },
    input() {
      if (this.selected && this.selected.length) {
        this.model[this.attribute] = this.multiple ? this.selected : this.selected[0];
      } else {
        this.model[this.attribute] = this.multiple ? [] : null;
      }
    },
    loadSelected() {
      if (this.model[this.attribute]) {
        if (this.multiple) {
          this.selected = this.model[this.attribute]
        } else {
          this.selected = [this.model[this.attribute]]
        }
      } else {
        this.selected = []
      }
    }
  },
  watch: {
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  mounted() {
    this.loadSelected();
    let locale = localStorage.getItem('locale');
    if (!locale) {
      locale = getUserLocale().split('-')[0];
    }
    i18n.locale = locale;
  }
}
</script>

<style scoped>

</style>